import Button from "@casino/legacyUi/Button";
import { cn } from "@workspace/frontend-ui";
import type { MouseEvent } from "react";

type Props = {
  handleClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

const FavouriteToggleContainer: FC<Props> = ({
  children,
  handleClick,
  className,
}) => (
  <Button
    size="xs"
    onClick={handleClick}
    className={cn("p-0 w-5 h-5 bg-white", className)}
    data-testid="favourite-toggle"
  >
    {children}
  </Button>
);

export default FavouriteToggleContainer;
